/**
 * User: n.gorte
 * Date: 17.09.2020
 * Time: 14:50
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import TimeLineItemMessageHeader from './TimeLineItemMessageHeader';
import BusinessObjectLink from '../BusinessObjectLink';
import { translation } from 'plugin/liferay-widgets-react-web';
import { EVENT_TYPE_DELETE, EVENT_TYPE_CREATE, EVENT_TYPE_UPDATE } from '../../constants/Constants';
import { getEventType } from '../../utils/event-type-util';

export const DefaultTimeLineItemMessageHeader = ({ changeRecord }) => {
    const { className, classPK } = changeRecord;
    const eventType = getEventType(changeRecord);

    const classNameTranslation = translation.trans(className);
    return (
        <TimeLineItemMessageHeader>
            <strong>
                {
                    (eventType === EVENT_TYPE_DELETE || eventType === EVENT_TYPE_CREATE) && (
                        <React.Fragment>
                            {`${classNameTranslation} `}
                            <BusinessObjectLink className={className} classPK={classPK}/>
                            {` wurde ${eventType === EVENT_TYPE_CREATE ? 'hinzugefügt' : 'gelöscht'}.`}
                        </React.Fragment>
                    )
                }

                {
                    eventType === EVENT_TYPE_UPDATE && (
                        <React.Fragment>
                            {`Datenänderung für ${classNameTranslation} `}
                            <BusinessObjectLink className={className} classPK={classPK}/>
                        </React.Fragment>
                    )
                }
            </strong>
        </TimeLineItemMessageHeader>
    );
};

DefaultTimeLineItemMessageHeader.propTypes = {
    changeRecord: PropTypes.object,
};



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/DefaultTimeLineItemMessageHeader.jsx